import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full grid grid-cols-8 2xl:grid-cols-11 pt-2" }
const _hoisted_2 = { class: "col-span-1 pr-4 text-right text-sm tracking-wide font-semibold" }
const _hoisted_3 = { class: "col-span-7 2xl:col-span-10 relative h-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute h-2 rounded bg-gray-200 w-full" }, null, -1)
const _hoisted_5 = { class: "pt-2 truncate text-black font-light text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", {
        class: "absolute h-2 rounded bg-indigo-400 transition-width duration-1000 ease-in-out",
        style: _normalizeStyle({width: _ctx.barProgress})
      }, null, 4),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
    ])
  ]))
}